import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const WorkpageApi = {
  async list() {
    return (await checkErrors(await fetchApi.api.get('workpages'))).data;
  },
  async get({ id }) {
    return (await checkErrors(await fetchApi.api.get(`workpages/${id}`))).data;
  },
};

export default WorkpageApi;
